import type { ReactNode } from 'react';
import { Badge, type BadgeSize, type BadgeTone } from '@viquard/doc-ui/components';
import type { CalendarEventStatus } from '../types.js';
import { resolveStatusLabel, useCalendarMessages } from '../i18n.js';

export interface StatusBadgeProps {
  readonly status: CalendarEventStatus;
  readonly size?: BadgeSize | undefined;
}

const TONE: Record<CalendarEventStatus, BadgeTone> = {
  scheduled: 'accent',
  live: 'success',
  past: 'neutral',
  cancelled: 'danger',
};

/**
 * Status pill — built on doc-ui's `Badge` (soft variant with leading
 * dot). One source of truth for the status color tones, so the
 * calendar inherits any global Badge theme tweaks for free.
 */
export function StatusBadge(props: StatusBadgeProps): ReactNode {
  const messages = useCalendarMessages();
  const { status, size = 'sm' } = props;
  return (
    <Badge tone={TONE[status]} size={size} variant="soft" dot>
      {resolveStatusLabel(messages, status)}
    </Badge>
  );
}
